import { createSlice, createAction } from "@reduxjs/toolkit";
import { groupBy } from "lodash";

const initialState = {
  currencies: [],
  countries: [],
  regionsWithCountries: [],
  regions: [],
};

export const slice = createSlice({
  name: "values",
  initialState,
  reducers: {
    setCurrencies: (state, action) => {
      state.currencies = action.payload;
    },
    setCountries: (state, action) => {
      state.countries = action.payload.list;
    },
    setRegionsWithCountries: (state, action) => {
      const regions = groupBy(
        action.payload.list,
        (country) => country.region.regionCode
      );

      state.regionsWithCountries = Object.values(regions).map((region) => {
        return {
          ...region[0].region,
          countries: region,
        };
      });
    },
  },
});

export const {
  setCurrencies,
  setCountries,
  setRegionsWithCountries,
} = slice.actions;

export const fetchCurrencies = createAction("fetchCurrencies");
export const fetchCountries = createAction("fetchCountries");

export const selectCurrencies = (state) => state.values.currencies;
export const selectCountries = (state) => state.values.countries;
export const selectRegions = (state) => state.values.regions;
export const selectRegionsWithCountries = (state) =>
  state.values.regionsWithCountries;

export default slice.reducer;
